/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetWorkbenchDestinationPerformanceParams = zod.object({
	start: zod.string(),
	end: zod.string()
});

export type GetWorkbenchDestinationPerformanceParams = zod.input<
	typeof GetWorkbenchDestinationPerformanceParams
>;
export type GetWorkbenchDestinationPerformanceParamsOutput = zod.output<
	typeof GetWorkbenchDestinationPerformanceParams
>;
